import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmergency = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 18,
	viewBox: "0 0 20 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14.7883 12.6018L10.902 6.57721C10.4059 5.8076 9.59411 5.8076 9.09803 6.57721L5.21173 12.6018C4.71564 13.3714 5.12153 14 6.1137 14H13.8863C14.8785 14 15.2844 13.3703 14.7883 12.6018Z",
		fill: "#475467"
	})]
});
const ForwardRef = forwardRef(SvgEmergency);
export { ForwardRef as ReactComponent };
